module.exports = __webpack_public_path__ + "img/mm.3cb6a5c7.svg";